module.exports = __webpack_public_path__ + "img/save.8b46caef.svg";